

































import { defineComponent } from "@vue/composition-api";
import { ContentSet } from "@scrile/api-provider/dist/api/ContentSetProvider";
import { ContentFeedTypeEnum } from "@scrile/api-provider/dist/projects/scrileConnect/ContentFeedProvider";
import { PostFileData } from "@/types";
import BaseInputFile from "@/components/BaseInputFile";
import BasePage from "@/components/BasePage";
import BaseSpinner from "@/components/BaseSpinner";
import ModalView from "@/components/ModalView";
import PageTitle from "@/components/PageTitle";
import CreateStoryView from "../CreateStoryView";
import EditPostOverview from "../EditPostOverview";

export default defineComponent({
  name: "CreatePostView",
  components: { BaseSpinner, EditPostOverview, BaseInputFile, BasePage, PageTitle, ModalView, CreateStoryView },
  props: {
    loading: { type: Boolean, required: true },
    postData: { type: Object as () => ContentSet | null },
    fileList: { type: Array as () => PostFileData[], required: true },
    show: { type: Boolean, required: true },
  },
  computed: {
    contentTypeEnum() {
      return ContentFeedTypeEnum;
    },
    type(): string {
      if (!this.postData) return "";
      return this.postData.type;
    },
  },
});
